import type { MemberRecord } from './api'

export interface DetailsForm {
  first_name: string
  last_name: string
  company: string
  email: string
  phone: string
  address_1: string
  address_2: string
  city: string
  state: string
  zipcode: string
  country: string
  do_not_email: boolean
  postal_renewals: boolean
}

type Flags = 'do_not_email' | 'postal_renewals'
export type DetailsPatch = Partial<Omit<DetailsForm, Flags>> & Partial<Pick<DetailsForm, Flags>>

const TEXT_KEYS = ['first_name', 'last_name', 'company', 'email', 'phone', 'address_1', 'address_2', 'city', 'state', 'zipcode', 'country'] as const

export function formFromRecord(m: MemberRecord): DetailsForm {
  return {
    first_name: m.first_name ?? '',
    last_name: m.last_name ?? '',
    company: m.company ?? '',
    email: m.email ?? '',
    phone: m.phone ?? '',
    address_1: m.address.address_1 ?? '',
    address_2: m.address.address_2 ?? '',
    city: m.address.city ?? '',
    state: m.address.state ?? '',
    zipcode: m.address.zipcode ?? '',
    country: m.address.country ?? 'US',
    do_not_email: !!m.do_not_email,
    postal_renewals: !!m.postal_renewals,
  }
}

/** Only what staff changed: the server touches nothing else. */
export function changedFields(before: DetailsForm, after: DetailsForm): DetailsPatch {
  const out: DetailsPatch = {}
  for (const k of TEXT_KEYS) {
    if (after[k].trim() !== before[k].trim()) out[k] = after[k].trim()
  }
  if (after.do_not_email !== before.do_not_email) out.do_not_email = after.do_not_email
  if (after.postal_renewals !== before.postal_renewals) out.postal_renewals = after.postal_renewals
  return out
}

/** A server refusal in plain words. */
export function detailsErrorText(status: number, payload: unknown): string {
  const d = (payload && typeof payload === 'object' ? (payload as { detail?: unknown }).detail : payload) as unknown
  if (typeof d === 'string' && status < 500) return d
  if (d && typeof d === 'object') {
    const o = d as { message?: unknown; errors?: unknown }
    if (typeof o.message === 'string') return o.message
    if (o.errors && typeof o.errors === 'object') {
      return Object.values(o.errors as Record<string, unknown>).map(String).join(' ')
    }
  }
  return status >= 500 ? 'Something went wrong saving. Nothing was changed.' : 'Those details could not be saved.'
}
